import { Model } from "vuex-fetch-factory";
import { AccessLogEntryRaw, AccessLogEntryModel } from "./accessLogEntry";
import { User, RelationType } from "shared/store/auth/types";

export interface AccessLogUserRaw extends User {
  entries: AccessLogEntryRaw[];
}

export class AccessLogUserModel
  implements Model<AccessLogUserModel, AccessLogUserRaw>
{
  public id = 0;
  public representee_id = 0;
  public first_name = "";
  public last_name = "";
  public organisation_name = "";
  public email_address = "";
  public relation_type: RelationType = RelationType.private;
  public entries: AccessLogEntryModel[] = [];

  public getNew(): AccessLogUserModel {
    return new AccessLogUserModel();
  }

  public fillModel(raw: AccessLogUserRaw): this {
    this.id = raw.id;
    this.representee_id = raw.representee_id;
    this.first_name = raw.first_name;
    this.last_name = raw.last_name;
    this.organisation_name = raw.organisation_name;
    this.email_address = raw.email_address;
    this.relation_type = raw.relation_type;
    this.entries = raw.entries.map((e): AccessLogEntryModel => {
      const model = new AccessLogEntryModel();
      model.fillModel(e);
      return model;
    });

    return this;
  }

  public getRaw(): AccessLogUserRaw {
    return {
      id: this.id,
      representee_id: this.representee_id,
      first_name: this.first_name,
      last_name: this.last_name,
      organisation_name: this.organisation_name,
      email_address: this.email_address,
      relation_type: this.relation_type,
      entries: this.entries.map((e): AccessLogEntryRaw => e.getRaw()),
    };
  }

  public get full_name(): string {
    return this.first_name + " " + this.last_name;
  }
}
